import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Brand } from '../Brand/Brand.js';
export function AuthShell({ title, subtitle, children, className }) {
    return (_jsx("div", { className: className, style: {
            minHeight: '100vh',
            background: 'var(--bg)',
            color: 'var(--text)',
            display: 'grid',
            placeItems: 'center',
            padding: 'var(--space-4)',
            fontFamily: 'var(--font-ui)',
        }, children: _jsxs("div", { style: {
                width: '100%',
                minWidth: 0,
                maxWidth: '28rem',
                background: 'var(--surface)',
                border: '1px solid var(--border)',
                borderRadius: 'var(--radius-card)',
                boxShadow: 'var(--elevation-sm)',
                padding: 'var(--space-8) var(--space-6)',
                display: 'grid',
                gap: 'var(--space-6)',
            }, children: [_jsxs("div", { style: { display: 'flex', alignItems: 'center', gap: 'var(--space-2)' }, children: [_jsx(Brand, { variant: "glyph" }), _jsx(Brand, { variant: "wordmark" })] }), title ? (_jsxs("div", { children: [_jsx("h1", { style: {
                                margin: 0,
                                fontFamily: 'var(--font-ui)',
                                fontWeight: 700,
                                fontSize: 'var(--font-size-xl)',
                                color: 'var(--text)',
                            }, children: title }), subtitle ? (_jsx("p", { style: { margin: '4px 0 0', color: 'var(--text-muted)', fontSize: 'var(--font-size-2xs)' }, children: subtitle })) : null] })) : null, _jsx("div", { children: children })] }) }));
}
//# sourceMappingURL=AuthShell.js.map